import {
    ISetRoomInfoModalAction,
    ISetRoomPasswordErrorAction,
    ISetRoomProtectionAction,
    SET_ROOM_INFO_MODAL,
    SET_ROOM_PASSWORD_ERROR,
    SET_ROOM_PROTECTION,
} from './types/roomProtection.action.types';
import {IFetchRoomProtection} from '../../incase-domain/rooms/room.player';
import {TypedTranslation} from '../../i18n';
import {LinkError, LinkErrorReason} from '../../util/linkError';

export const setRoomProtectionAction = (protection: IFetchRoomProtection): ISetRoomProtectionAction => ({
    type: SET_ROOM_PROTECTION,
    protection,
});

export const setPasswordErrorAction = (error: TypedTranslation | null): ISetRoomPasswordErrorAction => ({
    type: SET_ROOM_PASSWORD_ERROR,
    error,
});

export const setRoomInfoModalAction = (
    open: boolean,
    title: TypedTranslation | '',
    description: TypedTranslation | '',
    descriptionParams?: string[]
): ISetRoomInfoModalAction => ({
    type: SET_ROOM_INFO_MODAL,
    modal: {open, title, description, descriptionParams},
});

const LINK_ERROR_DESCRIPTIONS: Record<LinkErrorReason, TypedTranslation> = {
    missingParams: 'lobby.modals.invalidLinkMissingParams',
    unexpectedParams: 'lobby.modals.invalidLinkUnexpectedParams',
};

export const setInvalidLinkModalAction = (error: LinkError): ISetRoomInfoModalAction =>
    setRoomInfoModalAction(true, 'lobby.modals.invalidLink', LINK_ERROR_DESCRIPTIONS[error.reason], error.params ?? []);
